import React, { type FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  Modal,
  ModalHead,
  ModalBody,
  InputText,
  ModalFoot,
  Text,
  Button,
  SpacingVertical,
} from "mailup-web-components";
import { useRecoilCallback, useRecoilState, useResetRecoilState } from "recoil";
import { modalNewGroupState } from "Pages/ImportWizard/recoil/state/stateStep4";
import { addGroupCallback } from "Pages/ImportWizard/recoil/callbacks";

const ModalNewGroup: FC = () => {
  const intl = useIntl();
  const [{ Show, GroupName, IsDirty }, setModalNewGroupState] =
    useRecoilState(modalNewGroupState);
  const reset = useResetRecoilState(modalNewGroupState);
  const addGroup = useRecoilCallback(addGroupCallback, []);

  const handleChangeName = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setModalNewGroupState((prev) => ({
      ...prev,
      GroupName: value,
      IsDirty: true,
    }));
  };

  const confirmAddNewGroup = () => {
    addGroup(GroupName);
  };

  return (
    <Modal show={Show} onClose={reset} closeOnOverlayClick>
      <ModalHead
        title={intl.formatMessage({
          id: "Load.FileImport.ModalNewGroupTitle",
        })}
      />
      <ModalBody>
        <InputText
          value={GroupName}
          onChange={handleChangeName}
          variant={IsDirty && !GroupName ? "danger" : undefined}
        />
        <SpacingVertical />
        <Text>
          {intl.formatMessage({
            id: "Load.FileImport.ModalNewGroupDescr",
          })}
        </Text>
      </ModalBody>
      <ModalFoot>
        <Button kind="secondary" onClick={reset}>
          {intl.formatMessage({ id: "Load.MailupCommon.Cancel" })}
        </Button>
        <Button
          kind="primary"
          disabled={!GroupName}
          onClick={confirmAddNewGroup}
        >
          {intl.formatMessage({ id: "Load.FileImport.ModalNewGroupBtn" })}
        </Button>
      </ModalFoot>
    </Modal>
  );
};
export default ModalNewGroup;
